var $title = $('.product-tables .content h2 a');

$title.click(function(e) {
    e.preventDefault();
    $(this).parent('h2').parent('.wrapper').children('.table').toggleClass('show');
    $(this).toggleClass('active');
});